import IconSelector from 'icon-selector/src/icon-selector';
import styled from 'styled-components';

export const NameUpdatePop = styled.div(
    props => `
        width:100%;
        position: fixed;
        top:0;
        left:0;
        right:0;
        bottom:0;
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: rgba(0,0,0,0.4);
        z-index:9;
    `
);

export const NameUpdatePopContent = styled.div(
    props => `
        width: 60rem;
        display: flex;
        background-color: #fff;
        border-radius: 0.8rem;
        flex-direction: column;
        padding: 3rem;
    `
);

export const NameUpdatePopHeader = styled.div(
    props => `
        display: flex;
        flex-direction: column;
    `
);

export const HeaderText = styled.h2(
    props => `
        font-size: 2.8rem;
        color: #000000;
        font-weight: 900;
    `
);

export const PopBackBtn = styled.a(
    props => `
        align-self: flex-end;
        font-size: 1.1rem;
        color: #0091ff;
        font-weight: 900;
        text-decoration: none;
        cursor: pointer;
        text-transform: uppercase;
        margin-bottom: 1rem;
    `
);

export const ModalBody = styled.form(
    props => `
        width:100%;
        display: flex;
        margin-top: 2rem;
        flex-direction: column;
    `
);

export const NameInputLabel = styled.label(
    props => `
        font-size: 1.4rem;
        color: #000000;
        font-weight: 700;
        margin-bottom: 0.5rem;
    `
);

export const NameInput = styled.input(
    props => `
        width:100%;
        height: 4rem;
        border: 1px solid #e0e0e0;
        border-radius: 0.8rem;
        padding: 0 1rem;
        font-size: 1.4rem;
        font-weight: 700;
    `
);

export const ErrorMessage = styled.p(
    props => `
        font-size: 1.2rem;
        color: ${props.theme.colors.red.base || 'red'};
        margin-top: 0.5rem;
    `
);

export const SubmitBtn = styled.button(
    props => `
        margin-top: 2rem;
        width:10rem;
        height: 4rem;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: .4rem;
        outline: none;
        border: none;
        color: ${props.theme.colors.white.base};
        background-color: ${props.theme.colors.blue.base};
        margin-left: auto;
        text-transform: uppercase;
        font-weight: ${props.theme.font.fontWeight.bold};
        cursor: ${props.disabled ? '' : 'pointer'};
        pointer-events: ${props.disabled ? 'none' : ''};
        opacity: ${props.disabled ? 0.3 : 1};
    `
);